import PropTypes from 'prop-types';

//MUI
import { TextField } from "@mui/material"
import { Controller } from "react-hook-form"

const FormTextField = (props) =>
{
   const {
      control,
      name,
      rules = {},
      defaultValue = "",
      InputLabelProps = {},
      onChange,
      ...others
   } = props

   return <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field, fieldState }) =>
      {
         return (
            <TextField
               {...others}
               {...field}
               error={fieldState?.error ? true : undefined}
               helperText={fieldState?.error && fieldState?.error.message}
               InputLabelProps={{
                  sx: {
                     '&.MuiInputLabel-root.Mui-required .MuiFormLabel-asterisk': {
                        color: 'red',
                        fontWeight: 700
                     }
                  },
                  ...InputLabelProps
               }}
               onChange={(event, data) =>
               {
                  onChange ? onChange(event, data, field) : field.onChange(event, data);
               }}
               value={field.value !== undefined && field.value !== null ? field.value : ''}
               name={name}

            />
         )

      }}
   />
}

FormTextField.propTypes = {
   control: PropTypes.object,
   name: PropTypes.string,
   rules: PropTypes.object,
   defaultValue: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
   onChange: PropTypes.func,
   InputLabelProps: PropTypes.object
};

export default FormTextField;